import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        form: '=',
        sites: '=',
        repeatCount: '=',
        tags: '=',
        isCertificationForm: '='
    },
    template: `
        <div class="form">
            <form-row error="vm.form.errors.formSiteIds">
                <label class="label">{{ 'course.Access' | translate }} *<br>
                    <small>{{ 'form.Define the Sites that can access the form' | translate }}</small>
                </label>
                <div class="items">
                    <div ng-dropdown-multiselect=""
                        options="vm.siteFilter.options"
                        selected-model="vm.siteFilter.models"
                        extra-settings="vm.siteFilter.settings"
                        events="vm.siteFilter.events"
                        disabled="!vm.canManageSiteAccess"
                        translation-texts="vm.siteFilter.translations"
                    ></div>
                </div>
            </form-row>
            <form-row error="vm.form.errors.type">
              <label class="label">{{ 'forms.Type' | translate }} *</label>
              <div class="items">
                <select class="form-control"
                        ng-disabled="!vm.canManageForm"
                        ng-model="vm.form.model.type"
                        ng-change="!vm.isCertificationForm ? vm.initRedundantAttributes() : ''"
                        ng-options="type as label for (type, label) in vm.FORMS_TYPE_ENUM.LABELS">
                </select>
                <form-row-error></form-row-error>
              </div>
            </form-row>
            <form-row error="vm.form.errors.formCategoryId">
              <label class="label">{{ 'forms.Category' | translate }}</label>
              <div class="items">
                <select class="form-control"
                        ng-disabled="!vm.canManageForm"
                        ng-model="vm.form.model.formCategoryId"
                        ng-options="item.id as item.name for item in vm.categories">
                  <option value=""></option>
                </select>
                <form-row-error></form-row-error>
              </div>
            </form-row>
            <form-row error="vm.form.errors.formI18ns[vm.defaultLanguage].name">
                <label class="label">{{ 'forms.Form name' | translate }} *</label>
                <div class="items">
                    <input ng-disabled="!vm.canManageForm" ng-model="vm.form.model.formI18ns[vm.defaultLanguage].name" type="text" class="form-control">
                    <form-row-error></form-row-error>
                </div>
            </form-row>
            <form-row error="vm.form.errors.formI18ns[vm.defaultLanguage].description">
                <label class="label">{{ 'forms.Form description' | translate }}</label>
                <div class="items">
                    <textarea ng-disabled="!vm.canManageForm" ng-model="vm.form.model.formI18ns[vm.defaultLanguage].description" class="form-control"></textarea>
                    <form-row-error></form-row-error>
                </div>
            </form-row>
            <div class="row">
                <label class="label">{{ 'forms.Tags' | translate }}</label>
                <div class="items">
                    <forms-tag-manager form="vm.form" tags="vm.tags" resource="vm.FormTagResource"></forms-tag-manager>
                </div>
            </div>
            <form-row error="vm.form.errors.timeToAnswer" ng-if="vm.isCertificateTypeForm">
                <label class="label">{{ 'questions.Time for answering' | translate }}</label>
                <div class="items">
                    <timepicker-api ng-model="vm.form.model.timeToAnswer" ng-disabled="!vm.canManageForm"></timepicker-api>
                    <form-row-error></form-row-error>
                </div>
            </form-row>
            <form-row error="vm.form.errors.minimumPassRate" ng-if="vm.isCertificateTypeForm">
                <label class="label">{{ 'forms.Passing criteria' | translate }} <span ng-if="vm.form.model.type === vm.FORMS_TYPE_ENUM.KEYS.CERTIFICATION">*</span>
                    <small>{{ 'questions.% of the maximum score' | translate }}</small>
                </label>
                <div class="items">
                    <input ng-disabled="!vm.canManageForm" ng-model="vm.form.model.minimumPassRate" type="text" class="form-control">
                    <form-row-error></form-row-error>
                </div>
            </form-row>
            <form-row error="vm.form.errors.isRoomRequired" ng-if="vm.isCertificateTypeForm">
                <label class="label">{{ 'forms.Classroom mandatory' | translate }}</label>
                <div class="items">
                    <ul class="checkboxes">
                        <li>
                            <input ng-disabled="!vm.canManageForm" ng-model="vm.form.model.isRoomRequired" type="checkbox">
                        </li>
                    </ul>
                    <form-row-error></form-row-error>
                </div>
            </form-row>
            <form-row ng-if="vm.isCertificateTypeForm">
                <label class="label">{{ 'questions.Form can be filled' | translate }}</label>
                <div class="items">
                    <ul ng-if="vm.canManageForm" class="checkboxes03">
                        <li ng-repeat="option in vm.repeatOptions">
                            <label>
                                <input type="radio" ng-model="vm.repeatCount" ng-value="{{ option.value }}">
                                <span>{{ option.label }}</span>
                            </label>
                        </li>
                    </ul>
                    <span ng-if="!vm.canManageForm" class="text">{{ vm.selectedRepeatCount.label }}</span>
                </div>
            </form-row>
        </div>
    `
})

export default class {
    constructor ($rootScope, $state, $scope, $translate, lodash, FORMS_CATEGORY_FORMS_ENUM, FORM_REPEAT_ENUM, FORMS_TYPE_ENUM, FormService,
                 FormCategoryResource, FormTagResource, TokenService, FormCategoryService, PrivilegeService, FORMS_SITE_ACCESS_ENUM,
                 SiteService) {
        this.$state = $state;
        this.$scope = $scope;
        this.$translate = $translate;
        this.lodash = lodash;
        this.FORMS_CATEGORY_FORMS_ENUM = FORMS_CATEGORY_FORMS_ENUM;
        this.FORM_REPEAT_ENUM = FORM_REPEAT_ENUM;
        this.FORMS_TYPE_ENUM = FORMS_TYPE_ENUM;
        this.FormCategoryResource = FormCategoryResource;
        this.FormTagResource = FormTagResource;
        this.defaultLanguage = TokenService.getCompanyLanguage();
        this.FormService = FormService;
        this.FormCategoryService = FormCategoryService;
        this.TokenService = TokenService;
        this.PrivilegeService = PrivilegeService;
        this.FORMS_SITE_ACCESS_ENUM = FORMS_SITE_ACCESS_ENUM;
        this.SiteService = SiteService;
        this.isCertificateTypeForm = this.FormService.isCertificationForm(this.form.model);

        $scope.$on('set.formSiteIds', () => {
            if (this.form.model.siteAccess === this.FORMS_SITE_ACCESS_ENUM.KEYS.ALL_SITES) {
                this.form.model.formSiteIds = [];
            }
            else {
                this.form.model.formSiteIds = this.siteFilter.models.map(siteOption => siteOption.value);
            }
        });

        const listener = $rootScope.$on('form:reload', (event, updatedModel) => {
            this.form.model = updatedModel;
        });
        $scope.$on('$destroy', listener);
    }

    $onInit () {
        if (!this.form.model.id) {
            this.form.model.siteAccess = this.FORMS_SITE_ACCESS_ENUM.KEYS.SPECIFIED_SITES;
            if (this.showAllSites()) {
                this.form.model.siteAccess = this.FORMS_SITE_ACCESS_ENUM.KEYS.ALL_SITES;
            }
        }

        this.repeatOptions = this.FormService.getRepeatOptions();
        this.selectedRepeatCount = this.lodash.find(this.repeatOptions, { value: this.repeatCount });

        if (this.repeatCount === null) {
            this.repeatCount = this.FORM_REPEAT_ENUM.KEYS.UNLIMITED;
            this.selectedRepeatCount = {
                label: this.FORM_REPEAT_ENUM.LABELS.UNLIMITED
            };
        }

        this.form.model.tagsForm = [];
        if (this.form.model.tags) {
            this.tags = this.lodash.reduce(this.form.model.tags, (result, tag) => {
                this.form.model.tagsForm.push({ tag: tag.tag });
                result.push(tag.tag);
                return result;
            }, []);
        }
        else {
            this.tags = [];
        }

        this.FormCategoryResource.tree({ pageSize: 0 }).$promise.then((response) => {
            this.categories = this.FormCategoryService.mapSelectItems(response);
        });

        if (!this.TokenService.isFormModuleEnabled()) {
            if (this.form.model.type !== this.FORMS_TYPE_ENUM.KEYS.CERTIFICATION) {
                delete this.FORMS_TYPE_ENUM.KEYS.CERTIFICATION;
                delete this.FORMS_TYPE_ENUM.LABELS.CERTIFICATION;
            }
            if (this.form.model.type !== this.FORMS_TYPE_ENUM.KEYS.CERTIFICATION_FEEDBACK) {
                delete this.FORMS_TYPE_ENUM.KEYS.CERTIFICATION_FEEDBACK;
                delete this.FORMS_TYPE_ENUM.LABELS.CERTIFICATION_FEEDBACK;
            }
        }

        if (!this.TokenService.isFormEvaluationModuleEnabled() && this.form.model.type !== this.FORMS_TYPE_ENUM.KEYS.FORM_360_FEEDBACK) {
            delete this.FORMS_TYPE_ENUM.KEYS.FORM_360_FEEDBACK;
            delete this.FORMS_TYPE_ENUM.LABELS.FORM_360_FEEDBACK;
        }

        if (!this.TokenService.isFormSurveyModuleEnabled() && this.form.model.type !== this.FORMS_TYPE_ENUM.KEYS.SURVEY) {
            delete this.FORMS_TYPE_ENUM.KEYS.SURVEY;
            delete this.FORMS_TYPE_ENUM.LABELS.SURVEY;
        }
        this.$scope.$watch(() => this.form.model.type, (newVal, oldVal) => {
            if (newVal !== oldVal) {
                this.isCertificateTypeForm = this.FormService.isCertificationForm(this.form.model);
            }
        });
        this.initMultiSelect();
        this.canManageForm = this.FormService.canManageForm(this.form.model);
        this.canManageSiteAccess = this.PrivilegeService.isCompanyAdmin()
            || !this.form.model.id
            || (this.canManageForm && this.form.model.sites && this.form.model.sites.length === 1);
    }

    showAllSites () {
        return this.SiteService.hasAccessToAllSites(this.sites)
        || this.form.model.siteAccess === this.FORMS_SITE_ACCESS_ENUM.KEYS.ALL_SITES;
    }

    initMultiSelect () {
        this.allSitesOption = {
            value: null,
            label: this.$translate.instant('general.All sites')
        };

        const siteOptions = this.getSiteOptions();
        // NOTE: selectedOptions objects must be same as site options objects for multiSelect to work
        const selectedOptions = this.getSelectedSiteOptions(siteOptions);

        this.siteFilter = {
            models: selectedOptions,
            options: siteOptions,
            settings: {
                checkBoxes: true,
                showCheckAll: false,
                showUncheckAll: false,
                smartButtonMaxItems: 5,
                smartButtonTextConverter: (itemText) => itemText
            },
            events: {
                onItemDeselect: this.getItemCallback(),
                onItemSelect: this.getItemCallback()
            },
            translations: {
                buttonDefaultText: this.$translate.instant('filter.Select')
            }
        };
    }

    getSiteOptions () {
        const siteOptions = [];
        const cb = site => {
            return {
                value: site.id,
                label: site.name
            };
        };

        // 1. map all sites option if its selected or if user can manage site access
        if (this.showAllSites()) {
            siteOptions.push(this.allSitesOption);
        }
        // 2. map sites that user has access to via privileges
        this.lodash.forEach(this.sites, site => {
            siteOptions.push(cb(site));
        });

        // 3. map already attached course sites
        if (this.form.model.sites && this.form.model.sites.length) {
            this.lodash.forEach(this.form.model.sites, site => {
                siteOptions.push(cb(site));
            });
        }

        // 4. remove duplicates that might've come from sites and course.sites
        return this.lodash.uniqBy(siteOptions, option => option.value);
    }

    /**
     * Selected options have to be composed of siteOptions objects
     * they have to be references of each-other for multiSelect to work
     * @param siteOptions
     * @returns {[]}
     */
    getSelectedSiteOptions (siteOptions) {
        let selectedOptions = [];
        if (this.form.model.sites && this.form.model.sites.length) {
            const selectedSiteIds = this.form.model.sites.map(site => site.id);
            selectedOptions = siteOptions.filter(option => this.lodash.includes(selectedSiteIds, option.value));
        }
        else if (this.form.model.siteAccess === this.FORMS_SITE_ACCESS_ENUM.KEYS.ALL_SITES) {
            selectedOptions.push(this.allSitesOption);
        }
        else {
            selectedOptions.push(...siteOptions);
        }
        return selectedOptions;
    }

    /**
     * This callback makes sure that all sites option is always selected alone
     * - if all sites is selected uncheck every other option
     * - if any actual site option is selected uncheck's all sites option
     * @returns {Function}
     */
    getItemCallback () {
        return item => {
            const { siteFilter } = this;
            // if all sites option, set only it, otherwise deselect all sites if checkbox is selected
            if (item.value === null) {
                siteFilter.models = [this.allSitesOption];
                this.form.model.siteAccess = this.FORMS_SITE_ACCESS_ENUM.KEYS.ALL_SITES;
            }
            else {
                siteFilter.models = siteFilter.models.filter(model => model.value !== null);
                this.form.model.siteAccess = this.FORMS_SITE_ACCESS_ENUM.KEYS.SPECIFIED_SITES;
            }
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/components/forms/forms/actions/general/index.js